export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/outdoor_lifestyle.c2b4d50.svg";